<template>
  <v-card class="pa-0 rounded-0 elevation-0" :class="$vuetify.theme.dark ? 'blue-darken-5' : 'white-lighten-2'">
    <v-sheet class="currency-pairsSymbols" :class="$vuetify.theme.dark ? 'blue-darken-5 ' : 'white-lighten-1'">
      <v-card-text>
        <v-card-title class="pa-0">
          {{ $route.query.group }} Symbols
        </v-card-title>
        <v-dialog transition="scale-transition" origin="center center" max-width="324" v-model="dialog"
          content-class="deposit-withdraw-popup pairs-symbols-popup">
          <template v-slot:activator="{ on, attrs }">
            <v-btn tile small v-bind="attrs" v-on="on" :disabled="$canRoute('currency') !== 1" elevation="0" class="text-capitalize btn-account"
              color="teal-lighten-1">+ New Symbol</v-btn>
          </template>

          <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
            <v-card-title class="pb-3 text-left justify-start pl-3">
              Add New Pair
            </v-card-title>
            <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
              At First Select The Group, then write new currency pair
            </v-card-subtitle>
            <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
              <v-row>
                <v-col cols="12">
                  <fieldset>
                    <legend>Select Group*</legend>
                    <v-select solo :items="groupOptions" append-icon="mdi-chevron-down" label="Select group"
                      class="custom-select" hide-details v-model="selectedGroup" item-text="title"
                      item-value="id"></v-select>
                    <span v-if="showErrors && !selectedGroup" style="color: red; font-size: 12px; margin-top: 1px">Group
                      field is
                      required</span>
                  </fieldset>
                </v-col>
                <v-col cols="12">
                  <fieldset>
                    <legend>Pair Name*</legend>
                    <v-text-field label="Write Pair Name Here" single-line solo hide-details class="custom-select"
                      v-model="pairName"></v-text-field>
                    <span v-if="showErrors && !pairName" style="color: red; font-size: 12px; margin-top: 1px">Pair Name
                      field is
                      required</span>
                  </fieldset>
                </v-col>
              </v-row>
            </v-card>
            <v-card-actions class="mt-10">
              <v-row dense>
                <v-col cols="6">
                  <v-btn tile block @click="handleCreatePair" elevation="0" class="text-capitalize btn-account"
                    color="teal-lighten-1">Save Pair</v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn tile block outlined @click="closeDialog" elevation="0"
                    class="text-capitalize btn-account">Cancel</v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>
    </v-sheet>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { CURRENCY__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";

export default {
  data() {
    return {
      dialog: false,
      pairName: null,
      selectedGroup: null,
      showErrors: false,
    };
  },

  computed: {
    ...mapState("currencies", ["currencies", "groups"]),
    ...mapState("admins", ["loggedAdmin"]),

    groupOptions() {
      return this.groups.map((group) => ({
        id: group?.id,
        title: group?.title,
      }));
    },
  },

  methods: {
    ...mapActions("currencies", [
      CURRENCY__ACTIONS.ACTIVECURRENCYGROUPS,
      CURRENCY__ACTIONS.CREATESYMBOL,
    ]),

    handleCreatePair() {
      this.showErrors = true;
      if (this.pairName && this.selectedGroup) {
        const parameter = {
          partner_currency_group_id: this.selectedGroup,
          symbol: this.pairName,
        };
        this[CURRENCY__ACTIONS.CREATESYMBOL](parameter);
        this.closeDialog();
        return;
      }
    },

    closeDialog() {
      this.dialog = false;
      this.selectedGroup = null;
      this.pairName = null;
      this.showErrors = false;
    },
  },

  created() {
    this[CURRENCY__ACTIONS.ACTIVECURRENCYGROUPS]();
  },
};
</script>